import objectAssign from "lodash/assign";
import { isEmptyOrWhiteSpace } from "@/utils/Common";
import axios, { AxiosRequestConfig, Method } from "axios";

const axiosConfig: AxiosRequestConfig = { baseURL: "/api" };
if (!isEmptyOrWhiteSpace(process.env.VUE_APP_SERVER_PROXY)) {
  const proxy = process.env.VUE_APP_SERVER_PROXY;
  if (proxy) {
    const parts = proxy.split(":");
    axiosConfig.proxy = { host: parts[0], port: parts[1] };
  }
}
if (process.env.VUE_APP_SERVER_HOST) {
  let url: string = process.env.VUE_APP_SERVER_HOST;
  if (url.endsWith("/")) {
    url = url.replace(/\/$/g, "");
  }
  axiosConfig.baseURL = `${url}/api`;
}

const service = axios.create(axiosConfig);

export class Request {
  request<T>(url: string, pars: { [key: string]: any }, method: Method = "POST", headers?: any) {
    return service.request<T>({
      method: method,
      url: url,
      data: pars ?? {},
      timeout: 1000000,
      withCredentials: true,
      headers: objectAssign({ "Content-Type": "application/json" }, headers),
    });
  }
}
